import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import gridSelector from 'common/components/grid-view/controllers/selectors';

import { useGetProductFullView } from 'hooks';

import { checkDeployEnv } from 'utils/checkDeployEnv';

const useCheckIXOneCapture = () => {
  const { id: productId } = useParams();

  const { productFull } = useGetProductFullView({ productId });

  const selectedProductGrid = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const isProdEnv = checkDeployEnv('production');

  const shouldShowIXOneInProductDetail = () => {
    if (productFull?.isOverlayProduct) return false;

    return productFull?.isOwner;
  };

  const shouldShowIXOneInProductGrid = () => {
    if (selectedProductGrid?.length <= 0) return false;
    const isSomeProductOverlay = selectedProductGrid.some(
      (item) => item?.isOverlayProduct
    );
    if (isSomeProductOverlay) return false;

    return selectedProductGrid?.every((productItem) => productItem?.isOwner);
  };

  //* hide button on production
  if (isProdEnv) return false;

  return productId
    ? shouldShowIXOneInProductDetail()
    : shouldShowIXOneInProductGrid();
};

export default useCheckIXOneCapture;
